import React, { useState } from 'react'
import { MainLayout } from 'views/layouts'
import {
  Accent,
  ActionCard,
  ButtonContainer,
  CardDescription,
  CardEyebrow,
  CardFooter,
  CardTitle,
  Container,
  Description,
  Eyebrow,
  HeroCard,
  Title,
  TopContainer,
} from './styled'
import NewMapModal from './Components/NewMapModal'
import { useNavigate } from 'react-router-dom'
import { platformAdminRoutes } from 'router/routes'
import { useTeamMap } from './Hooks/useTeamMap'
import AddchartOutlinedIcon from '@mui/icons-material/AddchartOutlined'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'
import ArrowOutwardRoundedIcon from '@mui/icons-material/ArrowOutwardRounded'

const TeamDevelopment = () => {
  const navigate = useNavigate()
  const { createNewTeamMap } = useTeamMap()
  const [showNewMapModal, setShowNewMapModal] = useState(false)

  const handleHistory = () => {
    navigate(platformAdminRoutes.TeamDevelopmentHistory)
  }

  const handleNewMap = async (newMapName: string) => {
    await createNewTeamMap(newMapName)
    setShowNewMapModal(false)
  }

  return (
    <MainLayout>
      <Container>
        <NewMapModal
          show={showNewMapModal}
          setShow={setShowNewMapModal}
          onSave={handleNewMap}
        />
        <TopContainer>
          <HeroCard>
            <Eyebrow>Team Development</Eyebrow>
            <Title>
              Desarrollo de equipos
              <Accent>Una vista clara, accionable y estratégica.</Accent>
            </Title>
            <Description>
              Construye nuevos mapas para trabajar el desarrollo colectivo de tu organización o vuelve a consultar
              históricos para identificar patrones, comparar momentos y sostener decisiones de talento con contexto.
            </Description>
          </HeroCard>

          <ButtonContainer>
            <ActionCard type="button" primary onClick={() => setShowNewMapModal(true)}>
              <CardEyebrow primary>
                <AddchartOutlinedIcon sx={{ fontSize: 16, marginRight: '6px' }} />
                Acción principal
              </CardEyebrow>
              <CardTitle primary>Crear nuevo mapa</CardTitle>
              <CardDescription primary>
                Inicia un nuevo análisis del equipo y define el punto de partida para conversaciones de desarrollo más
                precisas.
              </CardDescription>
              <CardFooter primary>
                Empezar ahora
                <ArrowOutwardRoundedIcon sx={{ fontSize: 18 }} />
              </CardFooter>
            </ActionCard>

            <ActionCard type="button" onClick={handleHistory}>
              <CardEyebrow>
                <HistoryOutlinedIcon sx={{ fontSize: 16, marginRight: '6px' }} />
                Consulta
              </CardEyebrow>
              <CardTitle>Consultar históricos</CardTitle>
              <CardDescription>
                Revisa mapas anteriores, encuentra continuidad entre mediciones y recupera contexto para nuevas
                decisiones.
              </CardDescription>
              <CardFooter>
                Ver historial
                <ArrowOutwardRoundedIcon sx={{ fontSize: 18 }} />
              </CardFooter>
            </ActionCard>
          </ButtonContainer>
        </TopContainer>
      </Container>
    </MainLayout>
  )
}

export default TeamDevelopment
